var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    d: "M8.4 0c1.115 0 2.027.847 2.096 1.916l.004.13-.001.681H13.3c.387 0 .7.306.7.682 0 .348-.267.635-.612.677l-.088.005-.701-.001.001 8.865c0 1.086-.87 1.974-1.967 2.041L10.5 15h-7c-1.115 0-2.027-.847-2.096-1.916l-.004-.13-.001-8.864H.7c-.387 0-.7-.304-.7-.68 0-.349.267-.635.612-.677L.7 2.727h2.799l.001-.682C3.5.96 4.37.071 5.467.004L5.6 0h2.8zM2.799 4.09l.001 8.865c0 .347.267.634.612.676l.088.005h7c.357 0 .651-.26.695-.596l.005-.085-.001-8.865h-8.4zM8.4 1.364H5.6c-.357 0-.651.26-.695.596l-.005.085-.001.682h4.2l.001-.682c0-.347-.267-.634-.612-.676L8.4 1.364z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconSmall);
export default __webpack_public_path__ + "static/media/delete-icon-small.5a6793467862be1f06130c603017dfd0.svg";
export { ForwardRef as ReactComponent };